import { merge } from 'lodash';

import { Injectable } from '@angular/core';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Injectable({ providedIn: 'root' })
export class SnCameraGridFieldsGeneratorService {
  constructor() {}

  public getNameField(fieldConfig: SnFormFieldConfig = {}): SnFormFieldConfig {
    const baseFieldConfig: SnFormFieldConfig = {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        placeholder: t('cameras.grid.enterName'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getIsPrivateField(fieldConfig: SnFormFieldConfig = {}): SnFormFieldConfig {
    const baseFieldConfig: SnFormFieldConfig = {
      key: 'isPrivate',
      type: 'drag-slide-toggle',
      templateOptions: {
        appearance: 'fill',
        toggleLabel: t('cameras.grid.private'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getAutoplayField(fieldConfig: SnFormFieldConfig = {}): SnFormFieldConfig {
    const baseFieldConfig: SnFormFieldConfig = {
      key: 'autoplay',
      type: 'drag-slide-toggle',
      templateOptions: {
        appearance: 'fill',
        toggleLabel: t('cameras.grid.autoplay'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getisTemporaryField(fieldConfig: SnFormFieldConfig = {}): SnFormFieldConfig {
    const baseFieldConfig: SnFormFieldConfig = {
      key: 'isTemporary',
      type: 'drag-slide-toggle',
      templateOptions: {
        appearance: 'fill',
        toggleLabel: t('cameras.grid.temporary'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getGeometryField(fieldConfig: SnFormFieldConfig = {}): SnFormFieldConfig {
    const baseFieldConfig: SnFormFieldConfig = {
      key: 'geometry',
      type: 'radio',
      templateOptions: {
        appearance: 'fill',
        label: t('common.geometry'),
        options: [
          { label: '2 × 2', value: '2:2' },
          { label: '3 × 3', value: '3:3' },
          { label: '4 × 4', value: '4:4' },
          { label: '8 x 8', value: '8:8' },
          { label: '3 x 2', value: '3:2' },
          { label: '2 × 3', value: '2:3' },
          { label: '6 × 6', value: '6:6' },
        ],
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }
}
